import { css } from 'lit';

export const logItemCreateViewStyles = css`

  /*=== HOST ===*/

  :host {
    background: linear-gradient(
      180deg,
      var(--theme-color-primary-4, var(--yellow-2)) 0,
      var(--view-gradient-end-color) 200px
    );
    --view-gradient-end-color: var(--gray-1);
  }

  view-content {
    padding-top: 7rem;
  }

  header-bar .prefix {
    --link-color-default: var(--theme-color-primary-7);
    --link-color-visited: var(--theme-color-primary-7);
    --link-color-focus: var(--theme-color-primary-9);
  }

  p.subtitle.hero {
    --subtitle-color: var(--theme-color-primary-6);
  }

  .label-on-left {
    --label-width: 6rem;
  }

  sl-radio-button sl-icon.faux-prefix {
    position: relative;
    left: -8px;
    margin-left: 8px;
  }

  .form-footer {
    margin: 2.5rem 0;
    font-style: italic;
  }

`;
